<template>
  <Head>
    <title>
      Согласие на получение рекламных, информационных и иных сообщений
      {{ $titleEnd }}
    </title>
    <meta
      name="description"
      content="Ознакомиться с согласием на получение рекламных, информационных и иных сообщений жилого комплекса ВЭРИ на ул Ботаническая 29 в Москве от ГК ОСНОВА."
    />
    <meta
      property="og:title"
      :content="
        'Согласие на получение рекламных, информационных и иных сообщений ' +
        $titleEnd
      "
    />
    <meta
      property="og:description"
      content="Ознакомиться с согласием на получение рекламных, информационных и иных сообщений жилого комплекса ВЭРИ на ул Ботаническая 29 в Москве от ГК ОСНОВА."
    />
  </Head>
  <main class="main">
    <div class="container">
      <Breadcrumbs
        :links="[
          { name: 'Home', text: 'Главная' },
          {
            text: 'Согласие на получение рекламных, информационных и иных сообщений',
          },
        ]"
      />
      <h1 class="page-title h2">
        Согласие на получение рекламных, информационных и иных сообщений
      </h1>
      <p>
        Настоящим, выражая согласие путем проставления отметки («галочки») в
        соответствующем чек-боксе при заполнении своих контактных данных через
        форму на Сайте, действуя свободно, своей волей и в своем интересе, я
        подтверждаю, что даю Акционерному обществу «ГК ОСНОВА»,
        зарегистрированного по адресу: 142702, Московская обл., город Видное,
        поселок городского типа Бутово, территория жилой комплекс Бутово-Парк,
        д. 18, пом. 59 (далее - Оператор) согласие на направление мне рекламных,
        информационных и иных сообщений о товарах (продуктах), работах, услугах,
        публичных мероприятиях и маркетинговых программах Оператора (далее –
        Реклама) посредством:
      </p>
      <p>
        - СМС;<br />
        - сообщений в социальных сетях и мессенджеров;<br />
        - телефонных звонков;<br />
        - электронной почты;<br />
        - иным образом по предоставленным мною в адрес Оператора контактным
        данным.
      </p>

      <p>
        Перечень обрабатываемых персональных данных:<br />
        - фамилия, имя, отчество;<br />
        - контактные данные (номер телефона, адрес электронной почты, псевдоним
        (идентификатор) в социальных сетях и сервисах коммуникаций);<br />
        - иные персональные данные, сообщенные мною.
      </p>

      <p>
        Действия с персональными данными: автоматизированная и
        неавтоматизированная (смешанная) обработка посредством осуществления
        следующих действий: сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование,
        обезличивание, передача (предоставление, доступ), блокирование,
        удаление, уничтожение.
      </p>

      <p>
        Я подтверждаю, что являюсь дееспособным лицом и могу самостоятельно
        давать согласие на получение рекламы и обработку своих персональных
        данных с этой целью.
      </p>

      <p>
        Я также подтверждаю, что предоставленные мною номер телефона и/или адрес
        электронной почты принадлежат мне, а направляемая на них Реклама
        предназначена только для меня и не будет получаться третьими лицами, не
        давшими согласия на получение Рекламы.
      </p>

      <p>
        Я уведомлён(а), что:<br />
        - согласие может быть отозвано мной в любое время путем направления
        письменного запроса в адрес Оператора или на электронную почту:
        <a href="mailto:info@gk-osnova.ru">info@gk-osnova.ru</a>;<br />
        - мои персональные данные не будут передаваться третьим лицам без
        законных оснований;<br />
        - обработка осуществляется в соответствии с требованиями
        законодательства Российской Федерации.
      </p>

      <p>
        Настоящее согласие имеет юридическую силу, считается заполненным и
        является подписанным с момента заполнения формы путем принятия условий и
        проставления графического элемента согласия («галочки» в соответствующем
        чек-боксе), являющегося заменой собственноручной подписи.
      </p>

      <p>
        Настоящее согласие предоставляется на срок до достижения указанных целей
        обработки или до момента его отзыва.
      </p>

      <p>
        Политика обработки персональных данных расположена по адресу:
        <a href="/Политика_обработки_персональных_данных.pdf" target="_blank"
          >https://very-botsad.ru/Политика_обработки_персональных_данных.pdf</a
        >.
      </p>
    </div>
  </main>
</template>
<script>
import Breadcrumbs from "@/components/UI/Breadcrumbs.vue";
import { Head } from "@vueuse/head";
export default {
  components: {
    Head,
    Breadcrumbs,
  },
  data() {
    return {};
  },
};
</script>
